<utc-login-panel [content]="(loginPanelContent$ | async)!" [registrationContent]="(loginPanelRegistrationContent$ | async)!">
</utc-login-panel>
